module.exports = __webpack_public_path__ + "img/9-7.3ae22c05.png";